import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { PROMO_CODE } from '~/endpoints';
import { handleErrorResponse } from '~/helpers/api';
import { PromoCodeResponse } from '~/types/api';
import { MutationError } from '~/types/form';
import { PromoCodeResponseSchema } from '~/validation/api/promoCodeResponse';

type PromoCodeRequest = {
  locale: string;
  promo_code: string;
};

const sendPromoCode = async (obj: PromoCodeRequest) => {
  try {
    const response = await axios.post(PROMO_CODE, obj);

    const json = response.data;

    return PromoCodeResponseSchema.parse(json);
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw await handleErrorResponse(error.response);
    }

    throw error;
  }
};

export default function usePromoCodeMutation() {
  return useMutation<PromoCodeResponse, MutationError, PromoCodeRequest>({
    mutationFn: (obj) => {
      return sendPromoCode(obj);
    },
  });
}
